module.exports = __webpack_public_path__ + "img/7.f52bae0b.png";